// extracted by mini-css-extract-plugin
export default {"confirmSaveModal":"confirmSaveModal-NkecJ","title":"title-H7qaC","text":"text-mqcfh","header":"header-HC5_p","footer":"footer-tDdM5"};